/** @jsxImportSource @emotion/react */

import PropTypes from 'prop-types'
import { jsx } from '@emotion/react'
import css from '@emotion/css/macro'
import { convertToImperial } from '@sportninja/common/reducers/helpers'

import { Flex } from '../Layout'
import { font } from '../css'
import Picture from '../Picture'
// import { FollowBtnButton } from '../FollowBtn

const isDefined = (value) => typeof value !== 'undefined'

const PrivacySettingsExample = ({ defaultValues, isSelf, isVisible, values = {} }) => {
  let details = []
  const { height, weight, name_first, name_last, name_full } = values

  const displayHeight = isDefined(height) ? height : defaultValues.height
  const displayWeight = isDefined(weight) ? weight : defaultValues.weight
  const displayNameFirst = isDefined(name_first) ? name_first : defaultValues.nameFirst
  const displayFullName = isDefined(name_full) ? name_full : defaultValues.fullName
  const displayNameLast = isDefined(name_last) ? name_last : defaultValues.nameLast

  if (isSelf) {
    const [ ft, inches ] = convertToImperial(displayHeight)
    const isValidHeight = !isNaN(ft) && !isNaN(inches) && ft !== '' && inches !== ''

    if (isVisible) {
      if (isValidHeight) details.push(`${ft}' ${inches}"`)
      if (displayWeight) details.push(`${displayWeight} LBS`)

      if (details.length === 2) details = details.join(' / ')
    }
  }

  let imageId = defaultValues.imageId

  return (
    <Flex alignItems='center' justifyContent='space-between' css={css`
      height: 76px;
      border-radius: 2px;
      background-color: rgba(255, 255, 255, 0.09);
      padding: 0 16px;
    `}>
      {values.imageData ?
        <Picture key='1' imageData={isVisible ? values.imageData : null} size='xsmall' />
        :
        <Picture key='2' imageId={isVisible ? imageId : null} size='xsmall' />
      }
      <div css={css`
        margin: 0 18px;
        flex-basis: 100%;
      `}>
        <p css={css`
          ${font.title}
          font-size: 20px;
          font-weight: bold;
          letter-spacing: 1.64px;
        `}>
          {isSelf ? displayNameFirst : displayFullName}
          {' '}
          {isSelf && (isVisible ? displayNameLast : `${displayNameLast.charAt(0)}.`)}
        </p>
        {details &&
          <p css={css`
            opacity: 0.7;
            color: #FFFFFF;
            font-size: 13px;
            letter-spacing: 0.34px;
            margin-top: 4px;
          `}>
          {details}
          </p>
        }
      </div>
      {/*
        <FollowBtnButton type='button' css={css`
          override the css from the follow btn button
          cursor: default;

          &:hover {
            border-color: rgba(255, 255, 255, 0.2);
          }
        `}>
          {isPublic ? 'Follow' : 'Request'}
        </FollowBtnButton>
      */}
    </Flex>
  )
}

PrivacySettingsExample.propTypes = {
  defaultValues: PropTypes.shape({
    fullName: PropTypes.string,
    height: PropTypes.number,
    imageId: PropTypes.string,
    nameFirst: PropTypes.string,
    nameLast: PropTypes.string,
    weight: PropTypes.number
  }),
  isPublic: PropTypes.bool.isRequired,
  isSelf: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired
}

export default PrivacySettingsExample
